import { FormConfigurationDtoToEntity } from "src/app/features/ApplicationConfigurations/services/mappers/AppConfigurationDtoToEntity";
import type { DataGroupRequest } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import type { FormConfigurationsDto } from "src/app/features/ApplicationConfigurations/types/AppConfigurationDto";
import type { AppConfigurationEntity } from "src/app/features/ApplicationConfigurations/types/AppConfigurationEntity";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";

export const defaultAppConfigApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadFormConfigs: builder.query<AppConfigurationEntity, DataGroupRequest>({
            providesTags: ["appConfigurations"],
            query: ({ dataGroupCode }) => {
                const url = `${ResourceName.DATA_GROUPS}/${dataGroupCode}/form-configurations`;
                return {
                    url,
                    method: "GET",
                };
            },
            transformResponse: (response: FormConfigurationsDto) => {
                return FormConfigurationDtoToEntity(response);
            },
        }),
    }),
});

export const { useLoadFormConfigsQuery } = defaultAppConfigApi;
